import { Formik, Form } from "formik";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../header/Header";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import Footer from "../../footer/Footer";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import ModalPresentar from "../../modals/modalPresentar/modalPresentar";
import {
  deleteDocumento,
  getDatoListaDocumentos,
  sendDocumento,
} from "../../../services/DocumentosService";
import { useNavigate } from "react-router-dom";
import Constantes from "../../../../utils/Constantes";



const DocumentosActos = () => {
  const tam_ficheros = parseInt(Constantes.tam_ficheros);
  const tipoActo = localStorage.getItem("tipoActo")
  
  const navigate = useNavigate();
  // const location = useLocation();
  

  const [show, setShow] = useState({
    mensaje: false,
    modalPresentar: false,
  });
  const params = useParams();
  

  const [loading, setLoading] = useState(false);
  const [documentos, setDocumentos] = useState([]);
  // const [disablePresentar, setDisablePresentar] = useState(false);

  const [initialValuesCrated, setInitialValuesCrated] = useState({});
  const [files, setFiles] = useState([]);

  const parametrosFichero = {
    extension: "PDF",
    sizeMax: `${(tam_ficheros / 1048576)} MB`,
  };

  const eliminarDocumento = (id) => {
    deleteDocumento(params.id, id).then((data) => {
      setShow({
        mensaje: true,
        content: data,
        tipo: "tituloModal",
        aviso: false,
        destinoAviso: null,
        destinoCerrar: null,
      });

      if (!data.toString().startsWith("Error")) {
        // Actualiza el documento a "N" sin eliminarlo de la lista
        setDocumentos((prevDocs) =>
          prevDocs.map((d) =>
            d.xid === id ? { ...d, laportado: "N" } : d
          )
        );
      }
    });
  };



  const handleClose = (e) => {
    setShow(false);
  };
  useEffect(() => {
    getDatoListaDocumentos(params.id).then((data) => {
      
      if (data !== undefined) {
        setDocumentos(data);
        setLoading(true);

        if (data.length !== 0) {
          data.forEach((item) => {
            setInitialValuesCrated((prevState) => ({
              ...prevState,
              [item.xid]: "",
            }));
          });
        }
      }
    });
  }, [params.id]);

  const handleInput = (e, id) => {
    const file = e.target.files[0];

    // Si el usuario borra el archivo del input
    if (!file) {
      setFiles((prev) => prev.filter(([fid]) => fid !== id));
      return;
    }

    // Validar tipo PDF
    if (file.type !== "application/pdf") {
      setShow({
        mensaje: true,
        content: "Solo se permiten archivos PDF.",
        tipo: "tituloModal rojo",
        destinoAviso: null,
        destinoCerrar: null,
      });
      e.target.value = "";
      setFiles((prev) => prev.filter(([fid]) => fid !== id));
      return;
    }

    // Validar tamaño máximo (5 MB)
    if (file.size > tam_ficheros) {
      setShow({
        mensaje: true,
        content: `El archivo es demasiado grande (máx. ${(tam_ficheros / 1048576)} MB).`,
        tipo: "tituloModal rojo",
        destinoAviso: null,
        destinoCerrar: null,
      });
      e.target.value = "";
      setFiles((prev) => prev.filter(([fid]) => fid !== id));
      return;
    }

    // ✅ Reemplaza o agrega archivo
    setFiles((prev) => {
      const updated = prev.filter(([fid]) => fid !== id);
      return [...updated, [id, file]];
    });
  };



  return (
    <>
      <Header></Header>
      <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login fondo">
                <div className="tituloSolicitud">
                  <div className="d-flex align-items-center flex-column">
                    {/*<Titulo
                      titulo={"Acto S1 Variación de datos personales"}
                      tipo={"tituloPagina subTituloPagina"}
                    />*/}
                    {/* <p className="text-third-1">{datos.estado}</p> */}
                    <h2 className="tituloPagina">{tipoActo === "z9" ? "Acto Z9 Reconocimiento de Nivel de carrera" : "Acto S1 Variación de datos personales"}</h2>
                  </div>
                  <div className="datosPersonalesCarrera d-flex flex-column m-2">
                    <div>
                      <div className="d-flex justify-content-between">
                        {/*<Titulo
                          clases={"subSubTituloSolicitud p-2 fw-bold"}
                          tipo={"tituloCard noBg"}
                          titulo={"2. Aportar documentación"}
                        ></Titulo>*/}
                        <h3 className="tituloPagina noBg">2. Aportar documentación</h3>
                      </div>
                      <div className="separador"></div>
                      <p>
                        Tipos de fichero permitidos:{" "}
                        {parametrosFichero.extension}
                      </p>
                      <p>Tamaño máximo: {parametrosFichero.sizeMax}</p>
                    </div>

                    <div className="formulario">
                      <Formik
                        initialValues={initialValuesCrated}
                        validate={(valores) => {
                          const errores = {};
                          valores = files;
                          
                          // setDisablePresentar(true);
                          return errores;
                        }}
                        onSubmit={() => {
                          files.forEach(([id, file]) => {
                            sendDocumento(params?.id, [id, file]).then((data) => {
                              setShow({
                                mensaje: true,
                                content: data,
                                tipo: "tituloModal",
                                destinoAviso: null,
                                destinoCerrar: null,
                              });

                              if (!data.toString().startsWith("Error:")) {
                                setDocumentos((prev) =>
                                  prev.map((doc) =>
                                    doc.xid === id ? { ...doc, laportado: "S" } : doc
                                  )
                                );
                              }
                            });
                          });

                          // 🔹 Limpiamos los archivos seleccionados
                          setFiles([]);
                        }}
                      >
                      {({ errors }) => (
                        <>
                          <Form>
                            <>
                              <div className="datosProfesionales">
                                <div className="m-2"></div>
                                <div className="container-list-border">

                                  {documentos?.length !== 0 ? (
                                    documentos?.map((doc, i) =>
                                      doc?.laportado === "N" ? (
                                        <div key={i} className="row mb-3">
                                          {/* Nombre del documento */}
                                          <div className="col-12 col-sm-12 col-md-4 col-lg-3 d-flex align-items-center">
                                            {doc?.tdodtipdoc}
                                          </div>

                                          {/* Input para subir PDF */}
                                          <div className="col-12 col-sm-12 col-md-8 col-lg-6">
                                            <input
                                              type="file"
                                              accept="application/pdf"
                                              className="form-control"
                                              id={doc?.xid}
                                              onChange={(e) => handleInput(e, doc?.xid)}
                                            />
                                          </div>

                                          {/* Texto descriptivo */}
                                          <div className="col-12 col-md-5 d-flex align-items-center">
                                            <label htmlFor={doc?.ttipdoc} className="mb-0">
                                              {doc?.ttipdoc}{" "}
                                              {doc?.lobligatorio === "S" && (
                                                doc?.laportado === "N" ? (<span className="rojo">(Documentación obligatoria)</span>) : null
                                              )}
                                            </label>
                                          </div>
                                        </div>
                                      ) : (
                                        <div key={i} className="row mb-3">
                                          {/* Nombre del documento */}
                                          <div className="col-12 col-md-3 d-flex align-items-center">
                                            {doc?.tdodtipdoc}
                                          </div>

                                          {/* Iconos de acciones */}
                                          <div className="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0">
                                            <i
                                              className="fa-solid fa-eye fs-4 mx-2 cursorPointer faHover"
                                              onClick={() => {
                                                navigate(
                                                  `/descargarDocumentoActos/${params.id}/${doc?.xid}`,
                                                  { state: { tipoActo: tipoActo } }
                                                );
                                              }}
                                            ></i>
                                            <i
                                              className="fa-solid fa-xmark fs-3 mx-2 cursorPointer faHover rojo"
                                              onClick={() => {
                                                setShow({
                                                  mensaje: true,
                                                  content: `¿Desea eliminar el documento ${doc?.tdodtipdoc}?`,
                                                  tipo: "tituloModal",
                                                  aviso: true,
                                                  funcion: eliminarDocumento,
                                                  valorFuncion: doc?.xid,
                                                  destinoAviso: null,
                                                  destinoCerrar: null,
                                                });
                                              }}
                                            ></i>
                                          </div>

                                          {/* Texto descriptivo */}
                                          <div className="col-12 col-md-7 d-flex align-items-center">
                                            <label htmlFor={doc?.ttipdoc} className="mb-0">
                                              {doc?.ttipdoc}{" "}
                                              {doc?.lobligatorio === "S" && (
                                                doc?.laportado === "N" ? (<span className="rojo">(Documentación obligatoria)</span>) : null
                                              )}
                                            </label>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div className="card p-3 m-5">
                                      <p className="text-center p-5">No hay documentos que aportar.</p>
                                    </div>
                                  )}

                                </div>
                                <p> </p>
                              </div>
                            </>
                            <div className="gridBotones mb-2">
                              <button
                                id="volver"
                                className="btnRed rounded btnCancelarDocumentacion"
                                type="button"
                                onClick={() => {
                                  if (tipoActo === "z9") {
                                    navigate("/reconNivelCarrera")
                                  } else if (tipoActo === "s1") {
                                    navigate("/variacionDatosPersonales")
                                  }
                                }
                                }
                              >
                                <i className="fa-solid fa-rotate-left"></i>{" "}
                                Volver
                              </button>

                              {documentos?.length !== 0 ? (
                                <button
                                  id="grabarSolicitudCarrera"
                                  className="btn rounded btnPresentar"
                                  type="submit"
                                  title="Volver"
                                  aria-label="Volver a la selección de solicitudes"
                                  onClick={
                                    Object.keys(errors).length === 0
                                      ? () => { }
                                      : () => {
                                        setShow({
                                          mensaje: true,
                                          content:
                                            "Debe completar correctamente los datos obligatorios (Datos personales).",
                                          tipo: "tituloModal rojo",
                                          destinoAviso: null,
                                          destinoCerrar: null,
                                        });
                                      }
                                  }
                                  disabled={files.length === 0}
                                >
                                  <i className="fa-solid fa-save"></i> Guardar
                                </button>
                              ) : null}
                            </div>
                          </Form>
                        </>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </>
      ) : (
      <>
        <div className="error rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto">
          <SpinnerCircle></SpinnerCircle>
        </div>
      </>
        )}
    </div >
      <Footer></Footer>
  {
    show.mensaje ? (
      <>
        {" "}
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          content={show.content}
          content2={show.content2}
          tipo={show.tipo}
          aviso={show.aviso}
          destinoAviso={show.destinoAviso}
          destinoCerrar={show.destinoCerrar}
          funcion={show.funcion}
          valorFuncion={show.valorFuncion}
          boton={show.boton}
          contentBold={show.contentBold}
        ></ModalMensajes>
      </>
    ) : null
  }

  {
    show.modalPresentar ? (
      <ModalPresentar
        show={true}
        handleClose={handleClose}
        valores={show.valores}
        destinoCerrar={show?.destinoCerrar}
      ></ModalPresentar>
    ) : null
  }
    </>
  );
};
export default DocumentosActos;
